interface GetGapToDateOptions {
  measure: 'days' | 'hours';
  hours?: number;
  day?: number;
  month?: number;
  year?: number;
}

export const getGapToDate = ({ measure, hours, day, month, year }: GetGapToDateOptions): number => {
  const currentDate = new Date();

  const targetMonthDate = new Date(
    year ?? currentDate.getFullYear(),
    (month ?? currentDate.getMonth() + 1) - 1,
    day ?? currentDate.getDate(),
    hours ?? currentDate.getHours()
  );

  const timeDifference = targetMonthDate.getTime() - currentDate.getTime();

  let result: number;
  if (measure === 'hours') {
    result = timeDifference / (1000 * 60 * 60);
  } else {
    result = timeDifference / (1000 * 60 * 60 * 24);
  }

  return Math.ceil(result);
};
